// forked from https://github.com/GetStream/stream-chat-react/blob/master/src/components/ChannelHeader/ChannelHeader.tsx

import ArrowBack from 'components/material-symbol/icons/ArrowBack'
import PeopleAltOutlined from 'components/material-symbol/icons/PeopleAlt'
import React, { useMemo } from 'react'
import { useChannelStateContext, useChatContext } from 'stream-chat-react'
import ConversationActionsMenu from './components/conversation-actions'
import MembersModal from './components/members-modal'
import { isGroupChannel } from './utils'

const ChannelHeader = () => {
  const { channel } = useChannelStateContext()
  const { client, setActiveChannel } = useChatContext()
  const currentUserId = client.user?.id

  const otherMembers = useMemo(() => {
    if (!channel?.state?.members) return []

    return Object.values(channel.state.members)
      .filter(member => member.user_id !== currentUserId && member.user)
      .map(member => member.user)
  }, [channel?.state?.members, currentUserId])

  const { name, description } = channel?.data || {}
  const isGroupConversation = isGroupChannel(channel)

  const title = (() => {
    if (name) return name
    if (otherMembers.length > 3) {
      return `${otherMembers
        .slice(0, 3)
        .map(user => user.name)
        .join(', ')}, and ${otherMembers.length - 3} other(s)`
    }
    return otherMembers.map(user => user.name).join(', ')
  })()

  return (
    <div className="str-chat__channel-header">
      <div
        className="str-chat__header-hamburger"
        onClick={() => setActiveChannel(undefined)}
      >
        <ArrowBack />
      </div>
      <div className="str-chat__channel-header-info-container">
        <p className="str-chat__channel-header-title">{title}</p>
        {description && (
          <p className="str-chat__channel-header-subtitle">{description}</p>
        )}
        <p className="str-chat__channel-header-info">
          {isGroupConversation && otherMembers.length > 0 && (
            <>{`${otherMembers.length + 1} members`}</>
          )}
        </p>
      </div>
      <div className="str-chat__channel-header-end">
        {isGroupConversation && (
          <MembersModal
            currentUserId={currentUserId}
            channel={channel}
            trigger={
              <PeopleAltOutlined
                style={{ marginRight: '8px', cursor: 'pointer' }}
              />
            }
          />
        )}
        <ConversationActionsMenu channel={channel} />
      </div>
    </div>
  )
}

export default ChannelHeader
